const urlHelper = {
    getURLParam: (urlString, paramName) => {
        let url = new URL(urlString);
        return url.searchParams.get(paramName);
    },
    getAllURLParams: (urlString, paramName) => {
        let url = new URL(urlString);
        return url.searchParams.getAll(paramName);
    },
    getQueryStringParam: (urlString, fieldName = '') => {
        let value = '';
        let queryString = urlString.split('?')[1];
        if (typeof queryString !== 'undefined') {
            let queryStringList = queryString.split('&');
            queryStringList.forEach(fieldValue => {
                let fieldValueArray = fieldValue.split('=');
                if (decodeURIComponent(fieldValueArray[0]) === fieldName) {
                    value = decodeURIComponent(fieldValueArray[1])
                }
            });
        }
        return value;
    },
    getAllQueryStringParams: (urlString) => {
        let params = [];
        let queryString = urlString.split('?')[1];
        if (typeof queryString !== 'undefined') {
            let queryStringList = queryString.split('&');
            queryStringList.forEach(fieldValue => {
                let fieldValueArray = fieldValue.split('=');
                params.push({[fieldValueArray[0]]: fieldValueArray[1]})
            });
        }
        
        return params;
    },
    buildQueryString(params = {}) {
        return Object.keys(params).map(key => key + '=' + params[key]).join('&');
    }

}

export default urlHelper;